import { CreatorsHomeScreenProps, HomeComponent } from './HomeComponent'

export function HomeScreen(props: CreatorsHomeScreenProps) {
  return <HomeComponent />
}
